<template>
    <div class="news_list">
        <div id="documentary_img">
          <img src="https://www.top-link.com.tw/img/index_intro.839b1835.jpg" alt="">
        </div>
        <list :list='news' :router_name='router_name'></list>
        <div v-show="news.length == 0 && nodata == false" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
        </div>
        <div v-show="nodata" style="margin:40px auto;font-size:21px;text-align: center;">目前無展覽紀實</div>
        <moreButton button_text="返回首頁" button_href="/"></moreButton>
    </div>
</template>
<script>
import list from '@/components/list/list'
import MoreButton from '@/components/index/MoreButton'
export default {
    components: {
        'list': list,
        'moreButton': MoreButton,

    },
    data () {
    return {
      router_name:'documentary_page',
      news: [
      ],
      nodata:false,
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
  created(){
    var vm = this;
    var news_api = vm.API + 'api/tlweb/documentary?online=1&kind=4'
    // axios.get('http://localhost/api/tlweb/news')
    this.axios.get(news_api)
      .then(function (response) {
        vm.news = response.data.data.data
        
        for(var deleteHtmlTag=0;deleteHtmlTag<vm.news.length;deleteHtmlTag++){
          // console.log(vm.news[deleteHtmlTag].content);
            vm.news[deleteHtmlTag].content = vm.news[deleteHtmlTag].content.replace(/<[^>]+>|&[^;]+;/g,"").trim();
            // /<[^>]+>|&[^>]+;/g
            if(vm.news[deleteHtmlTag].title.length>80){
              vm.news[deleteHtmlTag].title=vm.news[deleteHtmlTag].title.slice(0,80)+"...";
            }else{
              // vm.news[deleteHtmlTag].title=vm.news[deleteHtmlTag].title;
            }
            
            if(vm.news[deleteHtmlTag].content.length>80){
              vm.news[deleteHtmlTag].content=vm.news[deleteHtmlTag].content.slice(0,80)+"...";
            }else{
              // vm.news[deleteHtmlTag].content=vm.news[deleteHtmlTag].content;
            }
            // console.log(vm.news[deleteHtmlTag].content);
            // console.log(vm.news[deleteHtmlTag].content.length);
        }
        // setTimeout(() => {
                if (vm.news.length == 0) {
                vm.nodata = true
                } else {
                vm.nodata = false
                }
            // } ,2500);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
}
</script>
<style>
#documentary_img{
  max-width: 1170px;
  margin: 45px auto;
}
#documentary_img img{
  width: 100%;
}
</style>


